/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { createBrowserHistory } from "history";
import createAppState from "./AppState";
import { globalVar } from "../utils/globalVar";

const { BASE_PATH } = globalVar;
export const appHistory = createBrowserHistory({
  basename: BASE_PATH || "",
});
export const appState = createAppState({ history: appHistory });
